export class BOHealthTecnologyDeliveredUnits{
    id:number;
    quantity:number;
    measurementMedicationUnits:string;
}